  export const SECRET = '02scU6wznPtRv0LJ0dYc70fE9HCFEtA7ltXEcGP4'
